import { useMutateMPEFetch } from '@retail/app/hooks';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { mpeApi } from '@retail/mgpris/config';
import {
  PriceSuggestionPriceActionDTO,
  PriceSuggestionPriceImportValidationDTO,
  ImportedPriceSuggestionPrice,
} from '@retail/price-suggestion/types';
import { QueryOptions } from '@shared/fetch-utils';
import { buildUrl } from '@shared/utils';

interface Props {
  assortmentId: number;
}

export function useMutateValidatePriceSuggestionPrices(
  { assortmentId }: Props,
  queryOptions: QueryOptions = {}
) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMutateMPEFetch<PriceSuggestionPriceImportValidationDTO, ImportedPriceSuggestionPrice[]>(
    {
      method: 'POST',
      url: () =>
        buildUrl({
          base: mpe.url,
          route: mpeApi.priceSuggestion.validatePrices.getFullLinkPath(),
          searchParams: { assortmentId },
        }),
      token,
      ...queryOptions,
    }
  );
}

export function useMutateCreatePriceSuggestionPrices(
  { assortmentId }: Props,
  queryOptions: QueryOptions = {}
) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMutateMPEFetch<PriceSuggestionPriceActionDTO>({
    method: 'POST',
    url: () =>
      buildUrl({
        base: mpe.url,
        route: mpeApi.priceSuggestion.getFullLinkPath(),
        searchParams: { assortmentId },
      }),
    token,
    ...queryOptions,
  });
}
